import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Card, CardContent, Fab, Grid, MenuItem, TextField, Tooltip, Typography } from '@material-ui/core';
import { Cancel, Delete, Edit, HelpOutline, Save } from '@material-ui/icons';
import { getLiveTheme } from './liveTheme';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    card: {
        textAlign: 'center',
        background: 'rgba(24, 24, 30, 0.92)',
        color: 'white',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 16,
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 12px 30px rgba(0,0,0,0.35)',
    },
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    detailPanel: {
        background: 'rgba(255, 255, 255, 0.04)',
        borderRadius: 24,
        padding: theme.spacing(2, 3, 5),
        border: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 18px 40px rgba(0,0,0,0.35)',
        marginTop: theme.spacing(2),
        '@media (max-width: 768px)': {
            marginTop: theme.spacing(1.5),
            borderRadius: 18,
            padding: theme.spacing(1.5, 1.25, 3),
        },
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    dense: {
        marginTop: theme.spacing(2),
    },
    menu: {
        width: 200,
    },
    input: {
        color: "white"
    },

    cssLabel: {
        '&$cssFocused': {
            color: "white",
        },
    },
    cssOutlinedInput: {
        background: 'rgba(12, 12, 18, 0.75)',
        borderRadius: 12,
        '&$cssFocused $notchedOutline': {
            borderColor: "white",
        },
    },
    cssFocused: {},
    notchedOutline: { borderColor: "rgba(255, 255, 255, 0.35)" },
    score: {
        width: '100%',
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: "white"
        }
    },
    pointsCorrectFormat: {
        fontSize: 20,
        fontWeight: 600,
        '@media (max-width: 768px)': {
            fontSize: 18,
        },
    },
    questionAnswerFormat: {
        fontSize: 20,
        lineHeight: 1.6,
        '@media (max-width: 768px)': {
            fontSize: 17,
            lineHeight: 1.55,
            wordBreak: 'break-word',
        },
    },
    status: {
        width: '100%',
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: "white"
        }
    },
    question: {
        width: '100%',
        maxWidth: 900,
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: "white"
        }
    },
    answer: {
        width: '100%',
        maxWidth: 800,
        '&:hover:not($disabled):not($cssFocused):not($error) $notchedOutline': {
            borderColor: "white"
        }
    },
    questionLabel: {
        fontSize: 26,
        fontWeight: 600,
        color: 'rgba(255, 255, 255, 0.9)',
        letterSpacing: 0.4,
        textTransform: 'uppercase',
        '@media (max-width: 768px)': {
            fontSize: 18,
            lineHeight: 1.2,
        },
    },
    primary: {
        color: 'rgba(236, 129, 255, 0.9)',
        fontSize: 16,
        letterSpacing: 0.5,
        textTransform: 'uppercase'
    },
    actionButton: {
        borderRadius: 999,
        textTransform: 'uppercase',
        fontWeight: 600,
        letterSpacing: 0.6,
        padding: '6px 16px',
        minHeight: 44,
        '@media (max-width: 768px)': {
            width: 'auto',
            minHeight: 36,
            padding: '4px 10px',
            fontSize: 13,
            margin: '0 !important',
        },
    },
    editButton: {
        background: 'var(--edit-button-bg, linear-gradient(120deg, rgba(236, 129, 255, 0.25), rgba(121, 134, 255, 0.3)))',
        border: '1px solid var(--edit-button-border, rgba(236, 129, 255, 0.6))',
        color: '#fff',
        boxShadow: 'var(--edit-button-shadow, 0 12px 24px rgba(0,0,0,0.35))',
        '&:hover': {
            background: 'var(--edit-button-bg-hover, linear-gradient(120deg, rgba(236, 129, 255, 0.4), rgba(121, 134, 255, 0.45)))',
        },
    },
    actionButtonPrimary: {
        background: 'linear-gradient(120deg, rgba(236, 129, 255, 0.6), rgba(121, 134, 255, 0.6))',
        color: '#fff',
        boxShadow: '0 10px 20px rgba(0,0,0,0.35)',
    },
    actionHeaderRow: {
        '@media (max-width: 768px)': {
            justifyContent: 'center',
            alignItems: 'center',
            columnGap: theme.spacing(1.5),
            rowGap: theme.spacing(1),
        },
    },
    actionHeaderLeft: {
        '@media (max-width: 768px)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flex: '0 0 auto',
        },
    },
    actionHeaderCenter: {
        '@media (max-width: 768px)': {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'nowrap',
            columnGap: theme.spacing(1.5),
            textAlign: 'center',
            width: 'auto',
            maxWidth: '100%',
            flex: '0 0 auto',
            whiteSpace: 'nowrap',
        },
    },
    hotkeyIcon: {
        fontSize: 20,
    },
    hotkeyContainer: {
        '@media (max-width: 768px)': {
            display: 'none',
        },
    },
    hotkeyButton: {
        borderRadius: 999,
        padding: '8px 18px',
        textTransform: 'none',
        fontWeight: 600,
        letterSpacing: 0.2,
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        color: 'rgba(255, 255, 255, 0.9)',
        boxShadow: '0 10px 18px rgba(0,0,0,0.25)',
        '&:hover': {
            background: 'rgba(255, 255, 255, 0.18)',
        },
        minHeight: 44,
    },
    hotkeyTooltip: {
        background: 'rgba(20, 20, 28, 0.95)',
        color: '#fff',
        maxWidth: 320,
        padding: theme.spacing(2),
        borderRadius: 12,
        border: '1px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 16px 32px rgba(0,0,0,0.45)',
    },
    hotkeyTooltipTitle: {
        fontWeight: 600,
        fontSize: 16,
        marginBottom: theme.spacing(1),
    },
    hotkeyTooltipList: {
        paddingLeft: theme.spacing(2),
        margin: 0,
        display: 'grid',
        gap: theme.spacing(0.5),
    },
    helperText: {
        color: 'rgba(255, 255, 255, 0.6)',
        fontSize: 12,
        marginTop: theme.spacing(0.5),
    },
    pointsCard: {
        display: 'inline-flex',
        alignItems: 'stretch',
        width: 'fit-content',
        minWidth: 160,
        '@media (max-width: 768px)': {
            width: '100%',
        },
    },
    pointsCardContent: {
        padding: theme.spacing(2),
        '&:last-child': {
            paddingBottom: theme.spacing(2),
        },
    },
    pointsCentered: {
        width: '100%',
        textAlign: 'center',
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginLeft: theme.spacing(2),
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0.6,
        textTransform: 'uppercase',
        whiteSpace: 'nowrap',
        '@media (max-width: 768px)': {
            marginLeft: theme.spacing(0.5),
            marginTop: 0,
            flexShrink: 0,
        },
    },
    statusDot: {
        width: 10,
        height: 10,
        borderRadius: '50%',
        boxShadow: '0 0 12px currentColor',
    },
    statusCorrect: {
        color: '#55d685',
    },
    statusIncorrect: {
        color: '#ff6b6b',
    },
    statusPending: {
        color: '#f5d76e',
        animation: '$statusPulse 1.6s ease-in-out infinite',
        textShadow: '0 0 10px rgba(245, 215, 110, 0.7)',
    },
    '@keyframes statusPulse': {
        '0%, 100%': { opacity: 0.7, textShadow: '0 0 6px rgba(245, 215, 110, 0.4)' },
        '50%': { opacity: 1, textShadow: '0 0 14px rgba(245, 215, 110, 0.9)' },
    },
    mobileSpacer: {
        '@media (max-width: 768px)': {
            display: 'none',
        },
    },
});

class QuestionDetails extends Component {

    state = {
        questionIsValid: false,
        questionDetail: {
            questionId: null,
            questionNumber: null,
            pointValue: null,
            questionDescription: null,
            correct: null,
            answer: null,
            contestId: this.props.contest.contestId,
            questionHour: this.props.contest.currentHour
        },
        toggleEdit: false
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    componentDidUpdate(prevProps, prevState) {
        if (!prevState.toggleEdit && this.state.toggleEdit && this.pointsInput) {
            this.pointsInput.focus();
            this.pointsInput.select();
        }
        const selectionChanged = this.props.selection !== prevProps.selection;
        const questionsChanged = this.props.question !== prevProps.question;
        // Typical usage (don't forget to compare props):
        if (selectionChanged || questionsChanged) {
            if (!selectionChanged && this.state.toggleEdit) {
                return
            }
            let question = this.getQuestion(this.props.selection)
            const shouldContinueEditing = this.state.toggleEdit;
            if (question) {
                this.setState({
                    questionDetail: {
                        ...this.state.questionDetail,
                        questionId: question.id,
                        questionNumber: this.props.selection,
                        pointValue: question.point_value ? question.point_value : '',
                        questionDescription: question.question_description ? question.question_description : '',
                        correct: question.correct ? question.correct : '',
                        answer: question.answer ? question.answer : '',
                        contestId: this.props.contest.contestId,
                        questionHour: this.props.contest.currentHour
                    },
                    toggleEdit: shouldContinueEditing,
                })
            } else {
                this.setState({
                    questionDetail: {
                        ...this.state.questionDetail,
                        questionId: '',
                        questionNumber: this.props.selection,
                        pointValue: '',
                        questionDescription: '',
                        correct: '',
                        answer: '',
                        contestId: this.props.contest.contestId,
                        questionHour: this.props.contest.currentHour
                    },
                    toggleEdit: shouldContinueEditing,
                })
            }
        } else {
            console.log('else the question still does not work')
        }
    }

    handleKeyDown = (event) => {
        if (!event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }
        const code = event.code;
        if (code === 'KeyE' && !this.state.toggleEdit && (this.props.user.clearance_id > 1)) {
            event.preventDefault();
            this.handleEdit(this.getQuestion(this.props.selection));
            return;
        }
        if (code === 'KeyC' && this.state.toggleEdit && (this.props.user.clearance_id > 1)) {
            event.preventDefault();
            this.toggleEdit();
        }
        if (code === 'KeyS' && this.state.toggleEdit && (this.props.user.clearance_id > 1)) {
            event.preventDefault();
            this.handleSave();
        }
    }

    getQuestion(number) {
        for (let each of this.props.question) {
            if (each.question_number == number) {
                return each;
            }
        }
        return null;
    }

    handleChangeFor = (propertyName) => (event) => {
        this.setState({
            questionDetail: {
                ...this.state.questionDetail,
                [propertyName]: event.target.value
            }
        });
    }

    handleStatusKeyDown = (event) => {
        const key = event.key ? event.key.toLowerCase() : '';
        const statusMap = {
            c: true,
            i: false,
            n: null
        };

        if (!Object.prototype.hasOwnProperty.call(statusMap, key)) {
            return;
        }

        event.preventDefault();
        this.setState({
            questionDetail: {
                ...this.state.questionDetail,
                correct: statusMap[key]
            }
        });
    }

    handleEdit = (id) => {
        if (id == null) {
            this.setState({
                toggleEdit: !this.state.toggleEdit,
                questionDetail: {
                    ...this.state.questionDetail,
                    questionId: id,
                    questionHour: this.props.contest.currentHour
                }
            })
        } else {
            this.setState({
                toggleEdit: !this.state.toggleEdit,
                questionDetail: {
                    ...this.state.questionDetail,
                    questionId: id.id,
                    questionHour: this.props.contest.currentHour
                }
            })
        }
    }

    toggleEdit = () => {
        this.setState({
            toggleEdit: !this.state.toggleEdit
        })
    }

    handleSave = () => {
        this.setState({
            questionDetail: {
                ...this.state.questionDetail,
                questionHour: this.props.contest.currentHour
            }
        })
        this.props.dispatch({
            type: 'ADD_OR_UPDATE_QUESTION',
            payload: this.state.questionDetail
        })
        this.setState({
            toggleEdit: !this.state.toggleEdit
        })
    }

    convertCorrect = (value) => {
        if (value == 'true') {
            return 'correct'
        } else if (value == 'false') {
            return 'incorrect'
        } else {
            return ''
        }
    }

    getStatusMeta = (value) => {
        if (value === true || value === 'true') {
            return { label: 'Correct', className: 'statusCorrect' };
        }
        if (value === false || value === 'false') {
            return { label: 'Incorrect', className: 'statusIncorrect' };
        }
        return { label: 'Pending', className: 'statusPending' };
    }

    render() {

        const { classes } = this.props
        const liveTheme = getLiveTheme(this.props.user.color);
        const primaryStyle = { color: liveTheme.primaryText };
        const isMac = typeof navigator !== 'undefined'
            && navigator.platform
            && navigator.platform.toLowerCase().includes('mac');
        const modifierLabel = isMac ? 'Option' : 'Alt';
        const statusMeta = this.getStatusMeta(this.state.questionDetail.correct);
        const questionExists = Boolean(this.getQuestion(this.props.selection));

        return (
            <div>
                <div className={classes.detailPanel}>
                    <Grid container spacing={3} justify="center" className={classes.actionHeaderRow} style={{ marginTop: 0 }}>
                    <Grid item xs="auto" sm={5} align="left" className={classes.actionHeaderLeft}>
                        {!this.state.toggleEdit && (this.props.user.clearance_id > 1) &&
                            <Button
                                className={`${classes.actionButton} ${classes.editButton}`}
                                color="secondary"
                                onClick={() => this.handleEdit(this.getQuestion(this.props.selection))}
                                style={{
                                    marginRight: 20,
                                    marginLeft: 0,
                                    '--edit-button-bg': liveTheme.buttonBackground,
                                    '--edit-button-border': liveTheme.primaryText,
                                    '--edit-button-bg-hover': liveTheme.buttonBackground,
                                    '--edit-button-shadow': '0 12px 24px rgba(0,0,0,0.35)',
                                }}
                            >
                                <Edit style={{ marginRight: 2, fontSize: 18 }} />Edit
                         </Button>}
                        {this.state.toggleEdit && (this.props.user.clearance_id > 1) &&
                            <Button className={classes.actionButton} color="secondary" onClick={this.toggleEdit} style={{ marginRight: 20, marginLeft: 0 }}>
                                <Cancel style={{ marginRight: 2, fontSize: 18 }} />Cancel
                         </Button>}
                        {this.state.toggleEdit && (this.props.user.clearance_id > 1) &&
                            <Button
                                className={`${classes.actionButton} ${classes.actionButtonPrimary}`}
                                color="primary"
                                onClick={this.handleSave}
                                style={{ marginRight: 20, marginLeft: 0, background: liveTheme.buttonBackground }}
                            >
                                <Save style={{ marginRight: 2, fontSize: 18 }} />Save
                         </Button>}
                    </Grid>
                    <Grid item xs="auto" sm={2} align="center" className={classes.actionHeaderCenter}>
                        <span className={classes.questionLabel}>Question {this.state.questionDetail.questionNumber}</span>
                        {!this.state.toggleEdit && (statusMeta.label !== 'Pending' || questionExists) && (
                            <span className={`${classes.statusBadge} ${classes[statusMeta.className]}`}>
                                <span className={classes.statusDot} />
                                {statusMeta.label}
                            </span>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={5} align="right" className={classes.hotkeyContainer}>
                        <Tooltip
                            arrow
                            classes={{ tooltip: classes.hotkeyTooltip }}
                            title={(
                                <div>
                                    <Typography className={classes.hotkeyTooltipTitle}>Hotkeys</Typography>
                                    <ul className={classes.hotkeyTooltipList}>
                                        <li><strong>{modifierLabel} + E</strong> — Edit</li>
                                        <li><strong>{modifierLabel} + C</strong> — Cancel</li>
                                        <li><strong>{modifierLabel} + S</strong> — Save</li>
                                        <li><strong>{modifierLabel} + 1–9</strong> — Select question</li>
                                        <li><strong>C / I / N</strong> — Status (Correct / Incorrect / N/A)</li>
                                    </ul>
                                </div>
                            )}
                        >
                            <Button className={classes.hotkeyButton} startIcon={<HelpOutline className={classes.hotkeyIcon} />}>
                                Hotkeys
                            </Button>
                        </Tooltip>
                    </Grid>

                    {this.state.toggleEdit ? (
                        <>
                            <Grid item xs={12} sm={2} align="left" >
                                <Card className={`${classes.card} ${classes.pointsCard}`}>
                                    <CardContent className={classes.pointsCardContent}>
                                        <span className={classes.primary} style={primaryStyle}><b>Points</b></span>
                                        {this.props.user.clearance_id > 1 && (
                                            <TextField
                                                align="left"
                                                id="outlined-name"
                                                label="points"
                                                className={classes.score}
                                                value={this.state.questionDetail.pointValue}
                                                onChange={this.handleChangeFor('pointValue')}
                                                margin="normal"
                                                variant="outlined"
                                                inputRef={(input) => {
                                                    this.pointsInput = input;
                                                }}
                                                InputProps={{
                                                    className: classes.input,
                                                    classes: {
                                                        root: classes.cssOutlinedInput,
                                                        focused: classes.cssFocused,
                                                        notchedOutline: classes.notchedOutline,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.input,
                                                    shrink: true
                                                }}
                                            />
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={8} align="left" >
                                <Card className={classes.card}>
                                    <CardContent>
                                        <span className={classes.primary} style={primaryStyle}><b>Question</b></span>
                                        {this.props.user.clearance_id > 1 && (
                                            <TextField
                                                align="left"
                                                id="outlined-multiline-flexible"
                                                label="question"
                                                color="white"
                                                multiline
                                                rows={3}
                                                value={this.state.questionDetail.questionDescription}
                                                onChange={this.handleChangeFor('questionDescription')}
                                                className={classes.question}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                InputProps={{
                                                    className: classes.input,
                                                    classes: {
                                                        root: classes.cssOutlinedInput,
                                                        focused: classes.cssFocused,
                                                        notchedOutline: classes.notchedOutline,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.input,
                                                    shrink: true,
                                                }}
                                            />
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={2} align="left">
                                <Card className={classes.card}>
                                    <CardContent>
                                        <span className={classes.primary} style={primaryStyle}><b>Status</b></span>
                                        {this.props.user.clearance_id > 1 && (
                                            <>
                                                <TextField
                                                    align="left"
                                                    id="outlined-name"
                                                    select
                                                    label="status"
                                                    className={classes.status}
                                                    value={this.state.questionDetail.correct}
                                                    onChange={this.handleChangeFor('correct')}
                                                    onKeyDown={this.handleStatusKeyDown}
                                                    SelectProps={{
                                                        MenuProps: {
                                                            className: classes.status,
                                                        },
                                                    }}
                                                    margin="normal"
                                                    variant="outlined"
                                                    InputProps={{
                                                        className: classes.input,
                                                        classes: {
                                                            root: classes.cssOutlinedInput,
                                                            focused: classes.cssFocused,
                                                            notchedOutline: classes.notchedOutline,
                                                        }
                                                    }}
                                                    InputLabelProps={{
                                                        className: classes.input,
                                                        shrink: true
                                                    }}
                                                >
                                                    <MenuItem key={'null'} value={null} className={classes.status}>
                                                        n/a
                                                    </MenuItem>
                                                    <MenuItem key={'correct'} value={true} className={classes.status}>
                                                        correct
                                                    </MenuItem>
                                                    <MenuItem key={'incorrect'} value={false} className={classes.status}>
                                                        incorrect
                                                    </MenuItem>
                                                </TextField>
                                                <Typography className={classes.helperText}>Tip: press C / I / N</Typography>
                                            </>
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item sm={2} className={classes.mobileSpacer} />
                            <Grid item xs={12} sm={8} align="left">
                                <Card className={classes.card}>
                                    <CardContent>
                                        <span className={classes.primary} style={primaryStyle}><b>Answer</b></span>
                                        {this.props.user.clearance_id > 1 && (
                                            <TextField
                                                align="left"
                                                id="outlined-multiline-flexible"
                                                color="white"
                                                multiline
                                                rows={3}
                                                value={this.state.questionDetail.answer}
                                                onChange={this.handleChangeFor('answer')}
                                                className={classes.answer}
                                                fullWidth
                                                margin="normal"
                                                variant="outlined"
                                                InputProps={{
                                                    className: classes.input,
                                                    classes: {
                                                        root: classes.cssOutlinedInput,
                                                        focused: classes.cssFocused,
                                                        notchedOutline: classes.notchedOutline,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.input,
                                                    shrink: true
                                                }}
                                            />
                                        )}
                                    </CardContent>
                                </Card>
                            </Grid>
                            <Grid item sm={2} className={classes.mobileSpacer} />
                        </>
                    ) : (
                        <>
                            <Grid item xs={12} sm={6} align="left" >
                                <Card className={classes.card}>
                                    <CardContent>
                                        <span className={classes.primary} style={primaryStyle}><b>Question</b></span>
                                        <br />
                                        <span className={classes.questionAnswerFormat}>{this.state.questionDetail.questionDescription}</span>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={4} align="left">
                                <Card className={classes.card}>
                                    <CardContent>
                                        <span className={classes.primary} style={primaryStyle}><b>Answer</b></span>
                                        <br />
                                        <span className={classes.questionAnswerFormat}>{this.state.questionDetail.answer}</span>
                                    </CardContent>
                                </Card>
                            </Grid>

                            <Grid item xs={12} sm={2} align="center" >
                                <Card className={`${classes.card} ${classes.pointsCard}`}>
                                    <CardContent className={`${classes.pointsCardContent} ${classes.pointsCentered}`}>
                                        <span className={classes.primary} style={primaryStyle}><b>Points</b></span>
                                        <br />
                                        <span className={classes.pointsCorrectFormat}>{this.state.questionDetail.pointValue}</span>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </>
                    )}
                    </Grid>
                </div>
            </div >
        )

    }

}

const mapStateToProps = state => ({
    currentContest: state.currentContest,
    user: state.user,
    team: state.team,
    question: state.question,
});

export default withRouter(connect(mapStateToProps)(withStyles(styles)(QuestionDetails)));
